import { render, staticRenderFns } from "./AuctionPriceDescription.vue?vue&type=template&id=b0723eb2&"
import script from "./AuctionPriceDescription.vue?vue&type=script&lang=js&"
export * from "./AuctionPriceDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports